//new code 
import React, { useEffect, useRef, useState } from 'react';
import Compressor from 'compressorjs';

const WebcamCapture = ({ onCapture }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [photoSrc, setPhotoSrc] = useState('');
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const getUserMedia = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.onloadedmetadata = () => {
            videoRef.current.play().catch((err) =>
              console.error(`An error occurred while trying to play the video: ${err}`)
            );
          };
        }
      } catch (err) {
        console.error(`An error occurred: ${err}`);
      }
    };

    getUserMedia();

    return () => {
      stopWebcam();
    };
  }, []);

  const stopWebcam = () => {
    const stream = videoRef.current?.srcObject;
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
  };

  const handleCapture = () => {
    const context = canvasRef.current.getContext('2d');
    context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);

    const now = new Date();
    const dateTime = now.toLocaleString();

    context.font = '20px Arial';
    context.fillStyle = 'white';
    context.fillText(dateTime, 10, canvasRef.current.height - 10);

    const dataUrl = canvasRef.current.toDataURL('image/png');
    const blob = dataURLtoBlob(dataUrl);
    compressImage(blob);
  };

  const dataURLtoBlob = (dataUrl) => {
    const arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const compressImage = (blob) => {
    new Compressor(blob, {
      quality: 0.2,
      maxWidth: 400,
      maxHeight: 300,
      success(result) {
        const reader = new FileReader();
        reader.readAsDataURL(result);
        reader.onloadend = () => {
          const base64Image = reader.result;
          setPhotoSrc(base64Image);

          const file = new File([result], 'compressed_image.jpg', { type: result.type });
          console.log(file);
          onCapture(file, base64Image);
        };
      },
      error(err) {
        console.error('Compression error:', err.message);
      }
    });
  };

  return (
    <div className="container" style={containerStyle}>
      <h4>Capture Photo</h4>
      <video ref={videoRef} width="580" height="480" autoPlay style={videoStyle}></video>
      <button
        onClick={handleCapture}
        style={{
          // ...buttonStyle,
          fontsize: '10',
          outline:'none',
          border:'none',
          color:'white',
          padding:'0.3rem',
          backgroundColor: isHovered ? '#4b5db2' : '#6174DD'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        Capture & Show
      </button>
      <canvas ref={canvasRef} width="640" height="480" style={{ display: 'none' }}></canvas>
      {photoSrc && <img src={photoSrc} alt="Captured screenshot" style={photoStyle} />}
    </div>
  );
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f0f0f0'
};

const videoStyle = {
  margin: '10px 0',
  width: '100%',
  maxWidth: '580px',
  height: 'auto'
};

const buttonStyle = {
  margin: '5px',
  fontSize: '14px',
  width: '40%',
  color: 'white',
  border: 'none',
  borderRadius: '5px',
  maxWidth: '200px',
  cursor: 'pointer',
  padding: '8px',
};

const photoStyle = {
  marginTop: '2rem',
  width: '100%',
  maxWidth: '640px',
  height: 'auto'
};

// Adding media queries directly in the component
const mediaQueries = `
  @media (max-width: 600px) {
    .container {
      height: auto;
      padding: 20px;
    }
    video {
      width: 100%;
      height: auto;
    }
    button {
      max-width: none;
    }
    img {
      width: 40%;
      height: auto;
    }
  }
`;

// Injecting media queries into the document head
const style = document.createElement('style');
style.appendChild(document.createTextNode(mediaQueries));
document.head.appendChild(style);

export default WebcamCapture;
